import { Show } from '@/components';
import { Label } from '@/components/ui/label';
import { hasAllowedRoles } from '@/helpers/roles';
import { requestStatus } from '@/helpers/status';
import { useUser } from '@/hooks';
import { CardForm, InputDescriptionForm } from '@/uiComponents/common';
import MultiSelectForm from '@/uiComponents/common/inputs/shadcn/multiSelect';
import SelectForm from '@/uiComponents/common/selects/selectNew';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SelectConfig from './selectedConfig/selectedConfig';
import { FormDescription } from '@/components/ui/form';
import { useFormContext } from 'react-hook-form';

const ConfigurationCard = ({
  t,
  className,
  mode,
  id,
  refetchStatus,
  bossOptions,
  rolesFormat,
  rolText,
}) => {
  const organization = useSelector((state) => state.app.selectedOrganization);
  const tenantId = useSelector((state) => state.app.tenantId);
  const { t: tGeneric } = useTranslation('translation', { keyPrefix: 'generic' });
  const { t: translate } = useTranslation('translation', { keyPrefix: 'forms.userForm' });
  const { roles } = useUser();
  const methods = useFormContext();
  const advantageNetworkStatus = methods.watch('advantageNetworkStatus');

  const incompatibleRoles = {
    associate: ['bosssales', 'salesteamlead'],
    bosssales: ['associate', 'salesteamlead'],
    salesteamlead: ['associate', 'bosssales'],
  };

  const filterIncompatibleRoles = (selectedRoles, allRoles) => {
    if (!allRoles) return [];
    if (!selectedRoles || selectedRoles.length === 0) return allRoles;

    const incompatible = selectedRoles.flatMap((role) => incompatibleRoles[role.value] || []);
    return allRoles?.filter((role) => !incompatible.includes(role.value));
  };
  const selectedRoles = methods.watch('roles') || [];
  const filteredRoles = filterIncompatibleRoles(selectedRoles, rolesFormat);
  return (
    <>
      {' '}
      <CardForm title={t('configurationCard.title')} className={className}>
        {id ? (
          <SelectForm
            label={
              mode === 'CONCIERGE'
                ? t('rowPublic.title', {
                    name: rolText,
                  })
                : t('rowPublic.titleProfile')
            }
            className={'tw-mb-6'}
            description={
              mode === 'CONCIERGE'
                ? t('rowPublic.description', {
                    name: rolText,
                  })
                : t('rowPublic.descriptionProfile')
            }
            name={'status'}
            isRequired={true}
            options={[
              { label: tGeneric('active'), value: 'ACTIVE' },
              { label: tGeneric('inactive'), value: 'INACTIVE' },
            ]}
          />
        ) : null}
        {(mode === 'CONCIERGE' || mode === 'USER') && (
          <>
            <MultiSelectForm
              label={translate('inputRoles.label')}
              description={''}
              name={'roles'}
              options={filteredRoles}
              isRequired={true}
              className={'tw-mb-6'}
              placeholder={translate('inputRoles.placeholder')}
            />
          </>
        )}
        <SelectForm
          name={'reportsToUserId'}
          options={bossOptions}
          className={'tw-mb-6'}
          label={translate('inputReport.label')}
          placeholder={translate('inputReport.placeholder')}
        />
        <Show.When isTrue={mode === 'CONCIERGE' && advantageNetworkStatus !== 'PENDING'}>
          <Label>
            {t('rowRequests.title')} {organization.marketName}
          </Label>

          <div className='row align-items-center tw-mt-3 tw-mb-2'>
            <div className='col-12'>
              <div className='d-flex align-items-center' style={{ gap: '20px' }}>
                {requestStatus(
                  advantageNetworkStatus,
                  t(`rowRequests.badge.${advantageNetworkStatus?.toLowerCase()}.label`),
                )}
                {hasAllowedRoles(roles, [
                  'superadministrator',
                  'marketadmin',
                  'affiliatecenter',
                ]) ? (
                  <SelectConfig
                    status={advantageNetworkStatus}
                    id={id}
                    mode='LINK'
                    usecase='request'
                    refetchStatus={refetchStatus}
                  />
                ) : null}
              </div>
            </div>
          </div>

          <FormDescription className='!tw-mb-6'>
            {t('rowRequests.description', {
              name: rolText,
            })}
          </FormDescription>
        </Show.When>

        {process.env.REACT_APP_TENANT_GRN === tenantId && mode === 'CONCIERGE' ? (
          <InputDescriptionForm
            name={'notes'}
            className={'tw-mb-6'}
            placeholder={''}
            isRequired={false}
            height={80}
            maxLength={500}
            label={translate('notes.label')}
            description={translate('notes.description', {
              name: rolText,
            })}
          />
        ) : null}
      </CardForm>
    </>
  );
};

export default ConfigurationCard;
